<button
  class="switch-btn map-btn"
  (click)="onButtonClick('map-btn')"
  [ngStyle]="{
    'background-color': mapBtnStyles.backgroundColor,
    'color': mapBtnStyles.color
  }"
>
  <img [src]="mapBtnStyles.imagePath" alt="Map icon" />
  Map View
</button>

<button
  class="switch-btn tree-btn"
  (click)="onButtonClick('tree-btn')"
  [ngStyle]="{
    'background-color': treeBtnStyles.backgroundColor,
    'color': treeBtnStyles.color
  }"
>
  <img [src]="treeBtnStyles.imagePath" alt="Tree icon" />
  Logical Tree
</button>